import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import { navigate } from 'gatsby-link';
import { withTranslation  } from 'react-i18next';
  
function BenefitMember({t, i18n}) {
    var gridStyle = { 
     paddingBottom: 10
    }

    var cell= {
      padding: 40,
      alignItems: 'stretch'
    }

    var title= {
      padding: 40,
      alignItems: 'left'
    }

    var cellWithImage = {
      ...cell,
      backgroundImage: `url('devices.svg')`,
      backgroundSize: '100% 100%',
    
    }
    
    var cellWithImage1 = {
      ...cell,
      backgroundImage: `url('connectCommunity.svg')`,
      backgroundSize: '100% 100%',
    
    }

    var cellWithImage2 = {
      ...cell,
      backgroundImage: `url('woman.svg')`,
      backgroundSize: '100% 100%',
    
    }

    return (
            <Grid container  style={gridStyle} id="Members">
                <Grid item xs={12} style={title}>
                    <Typography variant="h2" color="textPrimary">
                        {t("member title")}
                    </Typography>
                </Grid>
                <Grid item xs={6} style={cell}>    
                   <Typography variant="h4" color="textPrimary">
                        {t("group discussions")}
                    </Typography>
                    <br/>
                    <Typography variant="h5" color="textPrimary">
                       {t("topics")}
                    </Typography>
                </Grid>

                <Grid item xs={6}
                 style={cellWithImage}/>
       
                <Grid item xs={6}  style={cellWithImage1} />
                       
                <Grid item xs={6} style={cell}>
                    <Typography variant="h4" color="textPrimary">
                       {t("shared")}
                    </Typography>
                    <br/>
                    <Typography variant="h5" marginTop='5' color="textPrimary" >
                       {t("shared explained")}
                    </Typography>
                    
                </Grid>
                <Grid item xs={6} style={cell}>
                <Typography variant="h4" color="textPrimary">
                       {t("notify authorities")}
                    </Typography>
                    <br/>
                    <Typography variant="h5" color="textPrimary">
                       {t("notify authorities explained")}
                    </Typography>
                </Grid>
                <Grid item xs={6} style={cellWithImage2}/>
                    
                
               
                
                  <Box margin='auto' marginTop="20px">
                    <Button variant="contained" color="primary" onClick={()=>{navigate('../communitypage')}}>Demo</Button>
                  </Box>
                
              
                
            </Grid>

    );
   
}
export default withTranslation('landing') (BenefitMember)
